// extracted by mini-css-extract-plugin
export default {"timeBox":"TimeZoneWidget_timeBox__MspqO","time":"TimeZoneWidget_time__oZ4TB"};